const CF_LOCALE = process.env.LOCALE || "en-US"

const localeConfig = {
    supportedLocales: {
        "de-de": { lang: "de-DE", urlPrefix: "de" }, // Germany (German)
        "nl-be": { lang: "nl-BE", urlPrefix: "be-nl" }, // Belgium (Dutch)
        "de-at": { lang: "de-AT", urlPrefix: "at" }, // Austria (German)
        "fr-be": { lang: "fr-BE", urlPrefix: "be-fr" }, // Belgium (French)
        "bs-ba": { lang: "bs-BA", urlPrefix: "bih" }, // Bosnia and Herzegovina (Bosnian)
        "hr-hr": { lang: "hr-HR", urlPrefix: "hr" }, // Croatia (Croatian)
        "cs-cz": { lang: "cs-CZ", urlPrefix: "cz" }, // Czech Republic (Czech)
        "da-dk": { lang: "da-DK", urlPrefix: "dk" }, // Denmark (Danish)
        "fi-fi": { lang: "fi-FI", urlPrefix: "fi" }, // Finland (Finnish)
        "el-gr": { lang: "el-GR", urlPrefix: "gr" }, // Greece (Greek)
        "en-gb": { lang: "en-GB", urlPrefix: "uk" }, // United Kingdom (English)
        "en-mt": { lang: "en-MT", urlPrefix: "mt" }, // Malta (English)
        "hu-hu": { lang: "hu-HU", urlPrefix: "hu" }, // Hungary (Hungarian)
        "is-is": { lang: "is-IS", urlPrefix: "is" }, // Iceland (Icelandic)
        "he-il": { lang: "he-IL", urlPrefix: "il" }, // Israel (Hebrew)
        "it-it": { lang: "it-IT", urlPrefix: "it" }, // Italy (Italian)
        "nl-nl": { lang: "nl-NL", urlPrefix: "nl" }, // Netherlands (Dutch)
        "no-no": { lang: "no-NO", urlPrefix: "no" }, // Norway (Norwegian)
        "pl-pl": { lang: "pl-PL", urlPrefix: "pl" }, // Poland (Polish)
        "sr-rs": { lang: "sr-RS", urlPrefix: "rs" }, // Serbia (Serbian)
        "sk-sk": { lang: "sk-SK", urlPrefix: "sk" }, // Slovakia (Slovak)
        "sl-si": { lang: "sl-SI", urlPrefix: "si" }, // Slovenia (Slovenian)
        "es-es": { lang: "es-ES", urlPrefix: "es" }, // Spain (Spanish)
        "sv-se": { lang: "sv-SE", urlPrefix: "se" }, // Sweden (Swedish)
        "de-ch": { lang: "de-CH", urlPrefix: "ch-de" }, // Switzerland (German)
        "fr-ch": { lang: "fr-CH", urlPrefix: "ch-fr" }, // Switzerland (French)
        "pt-pt": { lang: "pt-PT", urlPrefix: "pt" }, // Portugal (Portuguese)
    },
    defaultLocale: {
        lang: "en-GB",
        urlPrefix: "",
    },
}

const localeNumberFormats = {
    "de-de": { decimalSeparator: "," },
    "nl-be": { decimalSeparator: "," },
    "de-at": { decimalSeparator: "," },
    "fr-be": { decimalSeparator: "," },
    "bs-ba": { decimalSeparator: "," },
    "hr-hr": { decimalSeparator: "," },
    "cs-cz": { decimalSeparator: "," },
    "da-dk": { decimalSeparator: "," },
    "fi-fi": { decimalSeparator: "," },
    "el-gr": { decimalSeparator: "," },
    "en-gb": { decimalSeparator: "." },
    "en-mt": { decimalSeparator: "." },
    "hu-hu": { decimalSeparator: "," },
    "is-is": { decimalSeparator: "," },
    "he-il": { decimalSeparator: "." },
    "it-it": { decimalSeparator: "," },
    "nl-nl": { decimalSeparator: "," },
    "no-no": { decimalSeparator: "," },
    "pl-pl": { decimalSeparator: "," },
    "sr-rs": { decimalSeparator: "," },
    "sk-sk": { decimalSeparator: "," },
    "sl-si": { decimalSeparator: "," },
    "es-es": { decimalSeparator: "," },
    "sv-se": { decimalSeparator: "," },
    "de-ch": { decimalSeparator: "." },
    "fr-ch": { decimalSeparator: "." },
    "pt-pt": { decimalSeparator: "," },
}

const getLangAttribute = pathname => {
    if (!pathname || pathname === "/") {
        return localeConfig.defaultLocale.lang
    }
    const locale = pathname.split("/")[1] || ""
    const lowercaseLocale = locale.toLowerCase()
    const found = Object.values(localeConfig.supportedLocales).find(
        config => config.urlPrefix.toLowerCase() === lowercaseLocale
    )

    return found?.lang || localeConfig.defaultLocale.lang
}

const getUrlLocale = locale => {
    if (!locale) return localeConfig.defaultLocale.urlPrefix

    const lowercaseLocale = locale.toLowerCase()
    const config = localeConfig.supportedLocales[lowercaseLocale]

    return config?.urlPrefix || localeConfig.defaultLocale.urlPrefix
}

const localeErrorPageMatches = Object.fromEntries([
    ["en-GB", "/*"],
    ...Object.values(localeConfig.supportedLocales)
        .filter(({ lang }) => lang !== "en-GB")
        .map(({ lang, urlPrefix }) => [lang, urlPrefix ? `/${urlPrefix}/*` : "/*"]),
])

module.exports = {
    CF_LOCALE,
    localeConfig,
    getLangAttribute,
    localeErrorPageMatches,
    getUrlLocale,
    localeNumberFormats,
}
